import {
  ISoccerMatchMissedPenaltyEventWithCount,
  ISoccerMatchPenaltyShotEventWithCount,
  ISoccerPenaltyEvent,
  SoccerMatchEventType,
} from "../../../../../types";
import {
  GlobalMissedPenaltyEvent,
  GlobalPenaltyShot,
} from "../../GlobalMatchEvents";

export default function GridPenaltyEvent({
  event,
}: {
  event: ISoccerPenaltyEvent;
}) {
  return (
    <div className="penalty-event-container">
      {event.subEvents.map((event, index) =>
        event.eventType === SoccerMatchEventType.PENALTY_SHOT ? (
          <GlobalPenaltyShot
            key={index}
            event={event as ISoccerMatchPenaltyShotEventWithCount}
            iconSize={8}
            showCount={true}
            wrapperClassName="player-event penalty-shot-event"
          />
        ) : (
          <GlobalMissedPenaltyEvent
            key={index}
            event={event as ISoccerMatchMissedPenaltyEventWithCount}
            iconSize={8}
            showCount={true}
            wrapperClassName="player-event penalty-event"
          />
        )
      )}
    </div>
  );
}
